import { RiListUnordered } from "react-icons/ri";
import { Button, Dropdown, Tooltip, type MenuProps } from "antd";
import { useState } from "react";
import type { DropdownExamplesVariantsType } from "./types/DropdownExamplesVariantsType";
import Icon from "../../../../masterComponents/Icon";

const DropdownExamplesVariants: React.FC<DropdownExamplesVariantsType> = ({ getExamples, reviewSourceValues, onSelectHash, isFinalLevel }) => {

    const [open, setOpen] = useState(false);

    const handleMenuClick = (e: { key: string; }) => {
        if (e.key !== "slider") {
            setOpen(false);
        }
    };

    const menuItems: MenuProps['items'] = [
        {
            key: 'getExamples',
            label: `Get Examples`,
            onClick: getExamples,
        },
        ...(!isFinalLevel ? [{
            key: 'anotherBatch',
            label: 'Another batch',
            onClick: onSelectHash,
        }] : []),
        {
            key: 'reviewSourceValues',
            label: `Review source values`,
            onClick: reviewSourceValues,
        },
    ];

    return (
        <Tooltip title="List" placement="right">
            <Dropdown overlayStyle={{ zIndex: 900 }}
                menu={{ items: menuItems, onClick: handleMenuClick }} open={open} onOpenChange={setOpen} trigger={["click"]} placement="bottomRight">
                <Button
                    type="primary"
                    className="primary-btn-color"
                    style={{
                        position: "relative",
                        zIndex: 6,
                        pointerEvents: "auto"
                    }}
                    icon={<Icon icon={RiListUnordered} styles={{ display: "flex" }} size={20} />}
                />
            </Dropdown>
        </Tooltip>
    );
}

export default DropdownExamplesVariants;
